import { Directive, TemplateRef } from "@angular/core";

@Directive({
  selector: "[editMode2]",
})
export class EditMode2Directive {
  constructor(public tpl: TemplateRef<any>) {}
}
